import { toast } from 'react-toastify';

export const showToastMessageUpdateRequest = (t, response) => {
    if (response.success) {
        toast.success(t('update_successfull'), {
            position: toast.POSITION.TOP_RIGHT
        });
    } else {
        toast.error(`${t('update_failed')} - ${t(response.error)}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 10000
        });
    }
}

export const showToastMessageDeleteRequest = (t, response, message = null) => {
    if (response.success) {
        toast.success(message || t('delete_successfull'), {
            position: toast.POSITION.TOP_RIGHT
        });
    } else {
        toast.error(`${t('delete_failed')} - ${t(response.error)}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 10000
        });
    }
}

export const showToastMessageRequestError = (action, t, err) => {
    const errorMessage = err?.data?.error ?? t('unknown');
    toast.error(`${action} - ${errorMessage}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: errorMessage ? 10000 : 3000
    });
}

// A product sync keeps running on the backend after the gateway stops waiting for it.
// Anything actually wrong with the sync surfaces as an error before that timeout,
// so a 504 is treated as a successful start rather than a failure.
export const isGatewayTimeout = (err) => err?.status === 504 || err?.originalStatus === 504;

export const showToastMessageSyncProductsRequestError = (t, err) => {
    if (isGatewayTimeout(err)) {
        toast.success(t('sync_successfull_data_visible_soon'), {
            position: toast.POSITION.TOP_RIGHT
        });
        return;
    }
    showToastMessageRequestError(t('sync_failed'), t, err);
}

export const showToastMessagePostRequest = (t, response) => {
    if (response.success) {
        toast.success(t('create_successfull'), {
            position: toast.POSITION.TOP_RIGHT
        });
    } else {
        toast.error(`${t('create_failed')} - ${response.error || response.message}`, {
            position: toast.POSITION.TOP_RIGHT, 
            autoClose: 10000
        });
    }
}

export const showToastMessage = (type, message, duration = 5000) => {
    const toastTypes = {
        success: toast.success,
        error: toast.error,
        warning: toast.warning,
        info: toast.info
    };

    const toastFn = toastTypes[type];
    toastFn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: duration
    });
}

export const showToastPromise = (promise, t, messages = {}) => {
    const defaultMessages = {
        pending: messages.pending || t('processing'),
        success: messages.success || t('success'),
        error: messages.error || t('failed')
    };

    return toast.promise(
        promise,
        {
            pending: {
                render: defaultMessages.pending,
                position: toast.POSITION.TOP_RIGHT
            },
            success: {
                render({ data }) {
                    // If data contains a custom message, use it
                    return data?.message || defaultMessages.success;
                },
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000
            },
            error: {
                render({ data }) {
                    // Extract error message from the response
                    const errorMessage = data?.data?.error || data?.error || defaultMessages.error;
                    return errorMessage;
                },
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 10000
            }
        }
    );
}